import { screenSizeSwitch } from '../../../../../../lib/helpers';
import BigMenuSubItemHeading from './BigMenuSubItemHeading';
import SmallMenuSubItemHeading from './SmallMenuSubItemHeading';


export default screenSizeSwitch([[991, SmallMenuSubItemHeading], BigMenuSubItemHeading]);
